let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5O05U")).then(() => parcelRequire('lyys6'));